import GridContainer from "@/components/common/GridContainer"
import React from "react"
import dynamic from "next/dynamic"
import Loading from "@/components/common/Loading"
import { getMarginsData } from "@/utils/utils"
import CommonGallery from "@/components/gallery/Gallery"

// const CommonGallery = dynamic(() => import("@/components/gallery/Gallery"), {
// 	loading: () => <Loading />,
// 	ssr: false,
// })

const Gallery = ({ data }) => {
	const images = data?.images || []
	const { marginTop, marginBottom } = getMarginsData(data)

	return (
		<GridContainer>
			<CommonGallery
				marginTop={marginTop}
				marginBottom={marginBottom}
				assets={images}
				className="col-mobile-8 col-tablet-8 col-desktop-16"
			/>
		</GridContainer>
	)
}

export default Gallery